import { clearChainProductDetails, clearSelectedProducts, clearSingleChainSortiment, editSelectedProduct, editSingleChainFilter, getInvoiceGroups, loadMoreSingleChainSortiment, prepareQueryOptions, updateChainProducts } from "../actions/singleChainSortiment";
import { setDropDown, setModal } from "../../common/actions/modal";

import SingleChainPage from "../components/SingleChainPage.jsx";
import { connect } from "react-redux";
import { createBoundFunction } from "../../common/util/reselect.js";
import { createFlowControl } from "../../common/util/flowControl";
import { createLocalization } from "../../common/util/localization.jsx";
import { exportCsv } from "../actions/multiChainSortiment";

import { scssVariables } from "../../common/util/config.jsx";

const mapStateToProps = () => {
    const flowControl = createFlowControl();
    const flowControlCounter = createFlowControl();

    return (state, ownProps) => ({
        deviceType: state.view.deviceType,
        flowControl: flowControl,
        flowControlCounter: flowControlCounter,
        height: state.view.innerHeight - parseInt(scssVariables.menuHeight),
        localization: createLocalization(state),
        singleChainSortiment: state.singleChainSortiment,
        startView: ownProps.match.params.view || "all",
        width: state.view.innerWidth,
    });
};

const mapDispatchToProps = {
    clearChainProductDetails,
    clearSingleChainSortiment,
    editSingleChainFilter,
    loadMoreSingleChainSortiment,
    prepareQueryOptions,
    setModal,
    setDropDown,
    updateChainProducts,
    editSelectedProduct,
    clearSelectedProducts,
    getInvoiceGroups,
    exportCsv,
};

const myLoadMoreSingleChainSortiment = createBoundFunction();
const myEditSingleChainFilter = createBoundFunction();

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    loadMoreSingleChainSortiment: myLoadMoreSingleChainSortiment((noOfProducts) => dispatchProps.loadMoreSingleChainSortiment(stateProps.singleChainSortiment, stateProps.productImage, noOfProducts)),
    editSingleChainFilter: myEditSingleChainFilter((change) => dispatchProps.editSingleChainFilter(change,
        myLoadMoreSingleChainSortiment((noOfProducts) => dispatchProps.loadMoreSingleChainSortiment(stateProps.singleChainSortiment, stateProps.productImage, noOfProducts))
    )),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(SingleChainPage);
